import { motion } from 'framer-motion';
import { MapPin, Images, Users } from 'lucide-react';
import { formatActivityDate } from '@utils/helpers';

const AlbumCard = ({ album, onClick }) => {
  const title = `${album.emoji ? `${album.emoji} ` : ''}${album.title || 'Vibe'}`;
  const sharedLabel =
    album.sharedBy?.length === 1
      ? `Shared by ${album.sharedBy[0]}`
      : album.sharedBy?.length > 1
        ? `Shared by ${album.sharedBy.slice(0, 2).join(', ')}${album.sharedBy.length > 2 ? '…' : ''}`
        : null;

  return (
    <motion.button
      type="button"
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      whileHover={{ y: -2, scale: 1.01 }}
      whileTap={{ scale: 0.99 }}
      transition={{ duration: 0.3 }}
      onClick={() => onClick?.(album)}
      className="memory-card group flex w-full overflow-hidden text-left transition-shadow hover:shadow-lg"
    >
      <div className="relative h-28 w-24 shrink-0 overflow-hidden sm:h-32 sm:w-28">
        {album.coverUrl ? (
          <img
            src={album.coverUrl}
            alt=""
            loading="lazy"
            className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
          />
        ) : (
          <div className="flex h-full w-full items-center justify-center bg-[var(--memory-card-2)] text-2xl">
            {album.emoji || '📷'}
          </div>
        )}
      </div>
      <div className="flex min-w-0 flex-1 flex-col justify-center gap-1.5 p-3.5 sm:p-4">
        <p className="truncate text-sm font-bold text-[var(--memory-text)] sm:text-base">{title}</p>
        <div className="flex flex-wrap items-center gap-x-3 gap-y-1 text-[11px] text-[var(--memory-muted)] sm:text-xs">
          <span className="inline-flex items-center gap-1">
            <Images size={12} />
            {album.photoCount} Photo{album.photoCount === 1 ? '' : 's'}
          </span>
          {album.participantCount != null && (
            <span className="inline-flex items-center gap-1">
              <Users size={12} />
              {album.participantCount} Participant{album.participantCount === 1 ? '' : 's'}
            </span>
          )}
        </div>
        {album.location ? (
          <p className="flex items-center gap-1 truncate text-[11px] text-[var(--memory-muted)]">
            <MapPin size={11} className="shrink-0" />
            {album.location}
          </p>
        ) : null}
        {album.dateTime ? (
          <p className="text-[11px] font-medium text-[var(--memory-muted)]">
            {formatActivityDate(album.dateTime)}
          </p>
        ) : null}
        {sharedLabel ? (
          <p className="text-[11px] font-semibold text-[var(--memory-accent)]">{sharedLabel}</p>
        ) : null}
      </div>
    </motion.button>
  );
};

export default AlbumCard;
